"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClubInvoiceProvider = exports.ClubInvoiceContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const ApiClubInvoiceRepo_1 = require("../../../modules/club-invoice/infra/ApiClubInvoiceRepo");
exports.ClubInvoiceContext = react_1.default.createContext(null);
const ClubInvoiceProvider = ({ children, }) => {
    const clubInvoiceRepo = (0, react_1.useMemo)(() => (0, ApiClubInvoiceRepo_1.createApiClubInvoiceRepo)(), []);
    const value = (0, react_1.useMemo)(() => ({
        getById: (id) => clubInvoiceRepo.getById(id),
        getAll: (page, pageSize, filter, startDate, endDate, sort, invoiceType, machineIds, clubIds) => clubInvoiceRepo.getAll(page, pageSize, filter, startDate, endDate, sort, invoiceType, machineIds, clubIds),
        generate: (clubId, year, month) => clubInvoiceRepo.generate(clubId, year, month),
    }), [clubInvoiceRepo]);
    return ((0, jsx_runtime_1.jsx)(exports.ClubInvoiceContext.Provider, { value: value, children: children }));
};
exports.ClubInvoiceProvider = ClubInvoiceProvider;
